import React, { Component } from 'react';
import InputText from './InputText';
import InputCheckbox from './InputCheckbox';
import './ToggleInputText.css';

class ToggleInputText extends Component {
  handleCheckboxChange = (e) => {
    const name = e.target.name;
    const value = e.target.checked ? false : null;

    this.props.handleChange({
      target: {
        name: name,
        value: value,
      },
    });
  };

  render() {
    const { toggleName, toggleLabel, toggleValue, ...others } = this.props;
    const disabled = toggleValue === false ? 'disabled' : '';
    const value = (toggleValue === false);

    return (
      <div className="ToggleInputText">
        <InputCheckbox
          name={toggleName}
          label={toggleLabel}
          value={value}
          handleChange={this.handleCheckboxChange}
        />
        <InputText disabled={disabled} {...others} />
      </div>
    );
  }
}

export default ToggleInputText;



// WEBPACK FOOTER //
// ./src/main/components/input/ToggleInputText.js